import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import ProductComboItemsBlock from './containers/ProductComboItemsBlock/ProductComboItemsBlock';
import ProductImageBlock from './containers/ProductImageBlock/ProductImageBlock';
import ProductInfoBlock from './containers/ProductInfoBlock/ProductInfoBlock';
import ProductSelectorsBlock from './containers/ProductSelectorsBlock/ProductSelectorsBlock';
import ProductSubmitBlock from './containers/ProductSubmitBlock/ProductSubmitBlock';
import { orderProductModalStore } from './store/orderProductModalStore';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import { modalStore } from 'src/mobx/modalStore';
import './style.scss';

export const OrderProductModal: FC = observer((): JSX.Element => {
  useEffect(() => {
    orderProductModalStore.init();
  }, []);

  return (
    <CustomModalComponent
      className="product-modal"
      isOpen={Boolean(modalStore.orderProduct)}
      onRequestClose={modalStore.closeOrderProduct}
      withCloseIcon
    >
      <ModalBackground className="full-height flex-row">
        <div className="d-flex flex-column half-width">
          <ProductImageBlock />
          {!orderProductModalStore.product?.type ? <ProductSelectorsBlock /> : <ProductInfoBlock />}
        </div>

        <div className="d-flex flex-column half-width justify-content-between">
          <ProductComboItemsBlock />
          <ProductSubmitBlock />
        </div>
      </ModalBackground>
    </CustomModalComponent>
  );
});
